import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=3e7ce36e&scoped=true&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"
import style0 from "./editor.vue?vue&type=style&index=0&id=3e7ce36e&lang=scss&scoped=true&"
import style1 from "./editor.vue?vue&type=style&index=1&id=3e7ce36e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7ce36e",
  null
  
)

export default component.exports